import { render, staticRenderFns } from "./LaudoAvaliacaoFundiariasModal.vue?vue&type=template&id=5857917a&scoped=true&lang=pug"
import script from "./LaudoAvaliacaoFundiariasModal.vue?vue&type=script&lang=js"
export * from "./LaudoAvaliacaoFundiariasModal.vue?vue&type=script&lang=js"
import style0 from "./LaudoAvaliacaoFundiariasModal.vue?vue&type=style&index=0&id=5857917a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5857917a",
  null
  
)

export default component.exports